import { AppConfig } from './AppConfig';

const env = process.env.REACT_APP_ENV; // '01_local';//

// tslint:disable-next-line:no-var-requires
const config = require(`./${env}.ts`).default as AppConfig;

export const gitHash = process.env.REACT_APP_GIT_HASH;

export default config;
